import { ChoiceGroup, IChoiceGroupOption, PrimaryButton } from "@fluentui/react";
import React from 'react';
import { IPreguntaEncuestaSatisfaccion } from '../../classes/satisfaction-survey/pregunta-encuesta';
import { IRespuestaEncuestaSatisfaccion } from '../../classes/satisfaction-survey/respuesta-encuesta';
import { showConfirmation } from '../../ioip/sdk/base';
import { PqrWebService } from '../../services/services';
import { ISatisfactionSurveyComponentProps } from './satisfaction-survey.props';
import { ISatisfactionSurveyComponentState } from './satisfaction-survey.state';

export class SatisfactionSurveyComponent extends React.Component<ISatisfactionSurveyComponentProps, ISatisfactionSurveyComponentState> {

  private _pqrWebService: PqrWebService;

  constructor(props: any) {
    super(props);
    this.state = {
      errors: {},
      idRadicadoEntrada64: decodeURI(window.location.hash.replace('#/satisfaction-survey/:', '')),
      isSurveyCompleted: false,
      itemsRender: [],
      respuestasSeleccionadas: []
    }
    this._pqrWebService = new PqrWebService();
  }

  async componentDidMount(): Promise<void> {
    const isSurveyCompleted = await this._pqrWebService.isSurveyCompletedAsync(this.state.idRadicadoEntrada64);
    if (isSurveyCompleted) {
      this.setState({
        isSurveyCompleted
      });
    }
    else {
      const preguntas: IPreguntaEncuestaSatisfaccion[] = await this._pqrWebService.getPreguntasEncuestaAsync();
      let preguntasRespuestas = []
      let i = 0;
      while (i < preguntas.length) {
        let respuestas: IRespuestaEncuestaSatisfaccion[] = await this._pqrWebService.getRespuestasByIdPreguntaAsync(preguntas[ i ].IdPreguntaEncuestaSatisfaccion);
        preguntasRespuestas.push({
          IdPreguntaEncuestaSatisfaccion: preguntas[ i ].IdPreguntaEncuestaSatisfaccion,
          Nombre: preguntas[ i ].Nombre,
          respuestas: respuestas.map(o => ({ key: o.IdRespuestaEncuestaSatisfaccion.toString(), text: o.Nombre }))
        })
        i++;
      }
      let itemsRender = preguntasRespuestas.map(o =>
        <div className='ms-Grid-row' style={{ paddingTop: '8px' }}>
          <ChoiceGroup
            defaultSelectedKey='0'
            options={o.respuestas}
            onChange={this._onChangeOpcionRespuesta.bind(this, o.IdPreguntaEncuestaSatisfaccion)}
            label={o.Nombre}
          />
          <br />
        </div>)
      this.setState({
        itemsRender,
        isSurveyCompleted: false
      });
    }
  }

  render(): JSX.Element {
    if (this.state.isSurveyCompleted) {
      return this.renderError();
    }
    else {
      return this.renderEncuesta();
    }
  }

  renderError(): JSX.Element {
    return <div className='ms-Grid'>
      <div className='ms-Grid-row'>
        <div className='ms-Grid-col ms-u-sm12' >
          <h1 className="ms-font-xl ms-fontWeight-semibold">Encuesta de satisfacción de usuario</h1>
        </div>
        <br />
        <div className='ms-Grid-col ms-u-sm12' >
          <h3 className="ms-font-l ms-fontWeight-regular">Esta encuesta ya fue diligenciada.</h3>
        </div>
      </div>
    </div>

  }

  renderEncuesta(): JSX.Element {
    return <div className='ms-Grid'>
      <div className='ms-Grid-row'>
        <div className='ms-Grid-col ms-u-sm12' >
          <h1 className="ms-font-xl ms-fontWeight-semibold">Encuesta de satisfacción de usuario</h1>
        </div>
      </div>
      {this.state.itemsRender}
      <div className='ms-Grid-row'>
        <div className='ms-Grid-col ms-u-sm12' style={{ marginTop: '15px', textAlign: 'right' }}>
          <PrimaryButton
            text='Enviar'
            onClick={this._sendSurveyResponsesAsync.bind(this)}
          />
        </div>
      </div>
    </div >
  }

  private _onChangeOpcionRespuesta(IdPregunta: number, ev?: React.FormEvent<HTMLElement | HTMLInputElement>, option?: IChoiceGroupOption): void {
    let respuestasSeleccionadas: IRespuestaEncuestaSatisfaccion[] = this.state.respuestasSeleccionadas;
    if (respuestasSeleccionadas.length > 0) {
      respuestasSeleccionadas = respuestasSeleccionadas.filter(o => o.IdPreguntaEncuestaSatisfaccion != IdPregunta)
    }
    let respuesta: IRespuestaEncuestaSatisfaccion = {
      IdPreguntaEncuestaSatisfaccion: IdPregunta,
      IdRespuestaEncuestaSatisfaccion: Number(option.key)
    }
    respuestasSeleccionadas.push(respuesta);
    this.setState({
      ...this.state,
      respuestasSeleccionadas
    });
  }

  private async _sendSurveyResponsesAsync(): Promise<void> {
    try {
      if (this.state.respuestasSeleccionadas.length <= 2) {
        alert('Por favor seleccione una respuesta para todas las preguntas.');
        return;
      }
      showConfirmation('Enviar solicitud', '¿Está seguro que desea enviar la encuesta? Una vez registrada no se podrá realizar ninguna modificación.', async () => {
        await this._pqrWebService.sendSurveyResponsesAsync(this.state.respuestasSeleccionadas, this.state.idRadicadoEntrada64);
        alert('Gracias por darnos su opinion, seguiremos mejorando para ofrecer un mejor servicio cada día.');
        window.location.href = '#/home';
      })

    } catch (ex) {
      this.setState({
        errors: {
          'error-general': ex.toString()
        }
      });
      alert(ex);
    }
  }

}